import * as React from 'react';
import styled, { css } from 'styled-components';
import { SanitasNavigationItem } from '../../..';
import { rem } from 'polished';

interface Props {
  children: Array<{
    id: string;
    category_name: string;
    url: string;
    category_id?: string;
    children?: Array<{
      id: string;
      category_name: string;
      url: string;
      category_id?: string;
    }>;
  }>;
  location?: any;
}

export const Navigation = ({ children, location = null }: Props) => {
  const isDropdown = children && children.length > 0;

  // if (location) {
  //   console.log(location);
  // }
  return (
    <Nav>
      <ListItems isNavDropdown={isDropdown}>
        {children.map((item, index) => {
          let isCurrent = false;
          if (location) {
            isCurrent = location.pathname.includes(item.url);
          }
          return (
            <SanitasNavigationItem
              id={item.id ?? item.category_id}
              category_name={item.category_name}
              url={item.url}
              children={item.children}
              key={index}
              isCurrent={isCurrent}
              location={location}
            />
          );
        })}
      </ListItems>
    </Nav>
  );
};

const navLikeCss = css`
  max-width: ${rem(304)};
  margin-right: ${rem(56)};

  ${({ theme }) => theme.mediab.l1300`
      margin-right: ${rem(24)};
  `}

  ${({ theme }) => theme.mediab.l925`
      margin-right: 0;
  `}

  nav {
    margin-right: 0 !important;
  }
`;

const Nav = styled.nav`
  ${navLikeCss};
`;

const listItemsLikeCss = css`
  padding: 0;
  margin: 0;
`;

const ListItems = styled.ul<{ isNavDropdown: boolean }>`
  ${listItemsLikeCss};
  border-radius: ${props => (props.isNavDropdown ? rem(4) : '0')} !important;
  overflow: ${props => (props.isNavDropdown ? 'hidden' : 'initial')} !important;
  margin-bottom: ${props => (props.isNavDropdown ? rem(0) : '0')};

  svg {
    display: ${props => (props.isNavDropdown ? 'block' : 'none')};
  }

  /* li:last-child {
    div {
      margin-bottom: 0;
    }
  } */
`;
